<template>
    <div v-if="hasErrors">
        <template v-if="type === 'default'">
            <div :class="errorClass" v-for="error in allErrors" :title="error">
                <slot :error="error" name="error">
                    {{ error }}
                </slot>
            </div>
        </template>
        <template v-if="type === 'alert'">
            <t-alert :message="allErrors" type="danger"> </t-alert>
        </template>
    </div>
</template>

<script>
import Errors from '../forms/Errors';
import TAlert from './Alert';

export default {
    components: { TAlert },
    props: {
        errors: {
            required: false,
            default() {
                return {};
            },
        },
        form: {
            required: false,
            default() {
                return {};
            },
        },
        field: {
            type: String,
        },
        errorClass: {
            type: String,
            default: 'invalid-feedback text-truncate',
        },
        type: {
            default: 'default',
        },
        listen: {
            default: false,
        },
    },
    data() {
        return {
            errorObject: new Errors(),
        };
    },
    created() {
        if (this.listen) {
            Bus.$on('newMessengerErrors', this.processMessages);
        }
    },
    beforeDestroy() {
        if (this.listen) {
            Bus.$off('newMessengerErrors', this.processMessages);
        }
    },
    methods: {
        processMessages(errors) {
            if (this.field) {
                errors = { [this.field]: _.get(errors, this.field) };
            }

            this.errorObject.set(errors);
        },
    },
    computed: {
        hasErrors() {
            if (this.field) {
                return this.errorObject && this.errorObject.has(this.field);
            }

            return this.errorObject.hasErrors();
        },
        allErrors() {
            if (this.field) {
                return _.get(this.errorObject.all(), this.field);
            }

            return this.errorObject.flatten();
        },
    },
    watch: {
        form: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal.errors instanceof Errors) {
                    this.errorObject.set(newVal.errors.all());
                } else if (newVal.errors instanceof SparkFormErrors) {
                    this.errorObject.set(newVal.errors.all());
                } else {
                    this.errorObject.set(newVal);
                }
            },
        },
        errors: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal instanceof Errors) {
                    this.errorObject.set(newVal.all());
                } else if (newVal instanceof SparkFormErrors) {
                    this.errorObject.set(newVal.all());
                } else {
                    this.errorObject.set(newVal);
                }
            },
        },
    },
};
</script>

<style lang="scss"></style>
